<template>
    <div class="fetch-record-dialog" v-show="show">
        <div class="fetch-record-mask">
            <div class="dialog-background">
                <div class="title dialog-title" v-show="index != MERGE_PROGRESS.CHECK">{{ message.title }}</div>
                <div class="title dialog-title" v-show="index == MERGE_PROGRESS.CHECK">{{ message.title_warning }}</div>
                <div class="update-step-content" v-show="index == MERGE_PROGRESS.FETCH">
                    <div class="toolbar">
                        <span class="prompt">{{ message.prompt }}</span>
                        <div class="deep-blue-btn btn-txt dialog-btn" @click="selectAll">{{ message.select_all }}</div>
                    </div>
                    <div class="content">
                        <RecordTask v-for="item in tasks" :key="item.taskName" :task="item" v-model:check="item.check">
                        </RecordTask>
                    </div>
                    <div class="buttons">
                        <div class="blue-btn btn-txt dialog-btn" @click="handleCancel">{{ message.cancel }}</div>
                        <div class="blue-btn btn-txt dialog-btn" @click="handleUpdate(false)">{{ message.update }}</div>
                    </div>
                </div>
                <div class="update-step-content" v-show="index == MERGE_PROGRESS.MERGE">
                    <div class="toolbar">
                        <span class="prompt">{{ message.prompt }}</span>
                    </div>
                    <div class="content">
                        <template v-for="item in mergeTask.tasks" :key="item.taskName">
                            <TaskResult :task="item" v-model:check="item.check" v-if="item.result"></TaskResult>
                        </template>
                    </div>
                    <div class="buttons">
                        <div class="blue-btn btn-txt dialog-btn" @click="handleMergeFinish">{{ message.close }}</div>
                    </div>
                </div>
                <div class="update-step-content" v-show="index == MERGE_PROGRESS.CHECK">
                    <div class="toolbar">
                        <span class="">{{ message.warning }}</span>
                    </div>
                    <div class="content">
                        <template v-for="item in mergeTask.tasks" :key="item.taskName">
                            <TaskDelete :task="item"
                                v-if="item.check && (item.taskType == RECORD_TASK_TYPE.DELETE_CLOUD || item.taskType == RECORD_TASK_TYPE.DELETE_LOCAL)">
                            </TaskDelete>
                        </template>
                    </div>
                    <div class="buttons">
                        <div class="blue-btn btn-txt dialog-btn" @click="handleCancelDelete">{{ message.cancel }}</div>
                        <div class="blue-btn btn-txt dialog-btn" @click="handleUpdate(true)">{{ message.update }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { API_GET_USER_RECORD } from '../../../js/api/index';
import { RECORD_TASK_TYPE } from '../../../data/user_record/record_task_type';
import RecordTask from './RecordTask.vue';
import TaskResult from './TaskResult.vue';
import TaskControl from '../../../js/record_task/task_control';
import { mergeTask } from '../../../js/record_task/task_store';
import { MERGE_PROGRESS } from '../../../data/user_record/merge_record_progress';
import { USER_RECORD_BUCKET } from '../../../js/api/user_record';
import EventBus from '../../../js/event_bus';
import TaskDelete from './TaskDelete.vue';
import { useUserStore } from '../../../js/user_data';
import { store } from '../../../store';
import BookData from '../../../js/book_data';

export default {
    name: "FetchRecord",
    data() {
        return {
            show: false,
            message: {
                title: "更新紀錄檔",
                update: "更新",
                cancel: "取消",
                prompt: "請勾選須更新的項目",
                select_all: "全部選取",
                close: "關閉",
                warning: "您選擇更新的項目，會刪除以下存檔，請確定是否執行",
                title_warning: "提醒！"
            },
            tasks: [],
            index: MERGE_PROGRESS.FETCH,
            mergeTask,
            MERGE_PROGRESS,
            RECORD_TASK_TYPE
        }
    },
    components: {
        RecordTask,
        TaskResult,
        TaskDelete
    },
    methods: {
        async fetchUserRecord() {
            const USER_DATA = useUserStore();
            const response = await API_GET_USER_RECORD(BookData.Instance.BookId, USER_DATA.userId)
                .catch(err => {
                    console.error("error::", err);
                });

            if (response && response.ok) {
                const data = await response.json();
                return data.content;
            } else {
                return null;
            }
        },
        /**
         * 
         * @param {Array} userRecord 
         */
        async showFetchRecord(userRecord) {
            this.index = MERGE_PROGRESS.FETCH;
            var userRecordLocal = userRecord.slice();
            var data = await this.fetchUserRecord();
            if (data === null) {
                EventBus.getInstance().getAppRefs().alertDialog.showDialog(
                    "提示",
                    "請確認網路連線狀態"
                );

                return;
            }
            var userRecordOnline = data.slice();

            // userRecordLocal.forEach(element => {
            //     console.log("local data:", element);
            // });

            // userRecordOnline.forEach(element => {
            //     console.log("online data:", element);
            // });

            var i, j;
            var recordTasks = [];
            for (i = userRecordLocal.length - 1; i >= 0; i--) {
                var recordTask = {};
                recordTask.taskName = userRecordLocal[i].log_name;
                recordTask.check = false;
                for (j = 0; j < userRecordOnline.length; j++) {
                    if (userRecordLocal[i].log_name == userRecordOnline[j].log_name) {
                        const localRecordUpdateTime = new Date(userRecordLocal[i].update_time);
                        const onlineRecordUpdateTime = new Date(userRecordOnline[j].update_time);

                        if (userRecordLocal[i].status == "delete" && userRecordOnline[j].save_staus == "delete") {
                            userRecordOnline.splice(j, 1);
                            userRecordLocal.splice(i, 1);

                            break;
                        }

                        if (localRecordUpdateTime.toString() != onlineRecordUpdateTime.toString()) {
                            if (localRecordUpdateTime > onlineRecordUpdateTime) {
                                recordTask.taskType = userRecordLocal[i].status == "delete" ? RECORD_TASK_TYPE.DELETE_CLOUD : RECORD_TASK_TYPE.UPDATE_TO_CLOUD;

                                if (recordTask.taskType == RECORD_TASK_TYPE.UPDATE_TO_CLOUD) {
                                    recordTask.taskType = userRecordOnline[j].save_staus == "delete" ? RECORD_TASK_TYPE.UPLOAD_TO_CLOUD : RECORD_TASK_TYPE.UPDATE_TO_CLOUD;
                                }

                                recordTask.updateTime = userRecordLocal[i].update_time;
                                recordTask.url = userRecordLocal[i].file_path;
                                recordTask.log_id = userRecordOnline[j].log_id;

                                if (recordTask.taskType == RECORD_TASK_TYPE.UPDATE_TO_CLOUD) {
                                    recordTask.cloud_url = `${USER_RECORD_BUCKET}${userRecordOnline[j].uid}/${userRecordOnline[j].book_id}/${userRecordOnline[j].log_name}.json?t=${new Date().getTime()}`;
                                }

                            } else if (localRecordUpdateTime < onlineRecordUpdateTime) {
                                recordTask.taskType = userRecordOnline[j].save_staus == "delete" ? RECORD_TASK_TYPE.DELETE_LOCAL : RECORD_TASK_TYPE.UPDATE_FROM_CLOUD;

                                if (recordTask.taskType == RECORD_TASK_TYPE.UPDATE_FROM_CLOUD) {
                                    recordTask.taskType = userRecordLocal[i].status == "delete" ? RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD : RECORD_TASK_TYPE.UPDATE_FROM_CLOUD;
                                }


                                recordTask.updateTime = userRecordOnline[j].update_time;
                                recordTask.url = recordTask.taskType == RECORD_TASK_TYPE.DELETE_LOCAL ?
                                    userRecordLocal[i].file_path :
                                    `${USER_RECORD_BUCKET}${userRecordOnline[j].uid}/${userRecordOnline[j].book_id}/${userRecordOnline[j].log_name}.json?t=${new Date().getTime()}`;
                                recordTask.log_id = userRecordLocal[i].id;
                            }
                            recordTasks.push(recordTask);
                        }

                        userRecordOnline.splice(j, 1);
                        userRecordLocal.splice(i, 1);

                        break;
                    }
                }
            }

            // console.log("local:", userRecordLocal)

            userRecordLocal.forEach(element => {
                if (element.status != "delete") {
                    var recordTask = {};
                    recordTask.check = false;
                    recordTask.taskName = element.log_name;
                    recordTask.taskType = RECORD_TASK_TYPE.UPLOAD_TO_CLOUD;
                    recordTask.updateTime = element.update_time;
                    recordTask.url = element.file_path;
                    recordTasks.push(recordTask);
                }
            });

            userRecordOnline.forEach(element => {
                if (element.save_staus != "delete") {
                    var recordTask = {};
                    recordTask.check = false;
                    recordTask.taskName = element.log_name;
                    recordTask.taskType = RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD;
                    recordTask.updateTime = element.update_time;
                    recordTask.url = `${USER_RECORD_BUCKET}${element.uid}/${element.book_id}/${element.log_name}.json`;
                    recordTasks.push(recordTask);
                }
            })

            // console.log("tasks:", recordTasks);

            this.tasks = recordTasks;
            if (this.tasks.length > 0) {
                this.show = true;
            } else {
                EventBus.getInstance().getAppRefs().alertDialog.showDialog(
                    "提示",
                    "目前紀錄都已同步囉！"
                )
            }
        },
        selectAll() {
            this.tasks.forEach(element => {
                element.check = true;
            })

            // console.log(this.tasks);
        },
        handleCancel() {
            this.show = false;
            store.fetchCloudRecord = false;
        },
        handleUpdate(force = false) {
            // TODO: 同步紀錄
            this.index = MERGE_PROGRESS.MERGE;

            if (force) {
                mergeTask.setTasks(this.tasks);
                TaskControl.Instance.startMerge();
                this.index = MERGE_PROGRESS.MERGE;
                return;
            }

            if (this.findDeleteTask()) {
                // 檢查刪除任務
                mergeTask.setTasks(this.tasks);
                this.index = MERGE_PROGRESS.CHECK;
            } else {
                mergeTask.setTasks(this.tasks);
                TaskControl.Instance.startMerge();
            }
        },
        findDeleteTask() {
            let i = 0;
            for (i = 0; i < this.tasks.length; i++) {
                if (this.tasks[i].check) {
                    if (this.tasks[i].taskType == RECORD_TASK_TYPE.DELETE_CLOUD || this.tasks[i].taskType == RECORD_TASK_TYPE.DELETE_LOCAL) {
                        return true;
                    }
                }
            }

            return false;
        },
        handleMergeFinish() {
            this.handleCancel();
            EventBus.instance.emit("load_record");
        },
        handleCancelDelete() {
            this.index = MERGE_PROGRESS.FETCH;
        }
    },
    created() {
    }
}
</script>
<style src="../../../css/dialog_style.css" scoped ></style>
<style scoped>
.fetch-record-mask {
    background: #0000007d;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fetch-record-dialog {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 999;
}

.dialog-background {
    position: absolute;
    background: white;
    width: 768px;
    height: 412px;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
}

.dialog-background * {
    margin: 0 0 0.5rem 0;
}

.title {
    margin: 1rem 0 0.5rem 0;
}

.toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 80%;
}

.toolbar * {
    margin: 0 1rem 0 0;
}

.content {
    width: 80%;
    height: 60%;
    overflow-y: auto;
}

.buttons {
    display: flex;
    flex-direction: row;
    margin: 0.5rem 0 0.5rem 0;
    justify-content: space-evenly;
    width: 100%;
}

.prompt {
    color: var(--dialog-txt-color-blue);
}

.update-step-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90%;
    align-items: center;
}
</style>